import { AbstractControl } from "@angular/forms";
import { isValid, parse } from 'date-fns';

export function bankGuaranteeRequiredValidator(c: AbstractControl): {[key:string]:boolean} | null{
  let contractNumber =  c.get("contractNumber");
  let bankGuaranteeAmount = c.get("bankGuaranteeAmount");
  let bankGuaranteeExpireDate = c.get("bankGuaranteeExpirationDate");

  // Project status is in the format of {id:number, name:string}
  let result = null;
  if (contractNumber.value && contractNumber.value.length > 0){
    // return result;
    if (!bankGuaranteeAmount.value){
      bankGuaranteeAmount.setErrors({"required": true});
      return {"bankGuaranteeAmountRequired": true};
    }

    if (!bankGuaranteeExpireDate.value){
      bankGuaranteeExpireDate.setErrors({"required": true});
      return {"bankGuaranteeExpireDateRequired": true};
    }
  }

  return null;
}
